import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';

import { SxErrorService } from 'app/services/sx-error.service';
import { Form } from 'app/models/form.model';

@Injectable()
export class FormsService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getForms(): Observable<Form[]> {
    return this.http
      .get<Form[]>(`${environment.apiEndpoint}/forms`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
